// extracted by mini-css-extract-plugin
module.exports = {"spiral":"styles_spiral__1zYvt"};